export default defineNuxtPlugin(() => {
    const is_loading = useIsLoading()

    return {
        provide: {
            startLoading: () => {
                is_loading.value = true
            },
            stopLoading: () => {
                is_loading.value = false
            },
        }
    }
})
